import React, {useEffect, useState} from "react";
import "./MessageBar.scss";

const MessageBar = (props) => {
	const [message, setMessage] = useState()
	
	useEffect(() => {
		setMessage(props.messageText || "")
	}, [props.messageText]);
	
	return <div className={`message__bar ${props.showOrHide ? "hide" : "show"}`}>
		<div className="message__bar-container">
			{message}
		</div>
	</div>
}

export default MessageBar;
